import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h4 className="footer-text">
        Driving made simple, safe, and stress-free
        <br /> your journey to confidence starts here.
      </h4>
      <div className="footer-columns">
        <div className="footer-column">
          <h4>Menu</h4>
          <ul>
            <li>
              {" "}
              <a href="#about">About</a>
            </li>
            <li>
              {" "}
              <a href="#reviews">Reviews</a>
            </li>
            <li>
              {" "}
              <a href="#services">Services</a>
            </li>
            <li>
              {" "}
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li>
              {" "}
              <a
                href=" https://www.gov.uk/book-theory-test"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Book Theory Test{" "}
              </a>
            </li>
            <li>
              {" "}
              <a
                href="https://www.gov.uk/book-driving-test"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Book Driving Test
              </a>
            </li>
            <li>
              {" "}
              <a
                href="https://www.gov.uk/change-driving-test"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Reschedule Test Date
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Opening Hours</h4>
          <p>
            Monday to Sunday: <br /> 9am – 8pm
          </p>
          <div className="contact-footer">
            <p>
              Tel: <br /> 07958142870
            </p>
            <p>Email: Autodrivr@gmail.com</p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <small className="rights">2025 All rights reserved.</small>
        <strong>Auto DrivR</strong>
      </div>
    </footer>
  );
};

export default Footer;
